/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, FC, MouseEvent } from "react";
import { SHUFFLE, REPEAT, LINEAR, REPEAT_1 } from "../../store/types";

import PlayerTrack from "../layout/dropdown/PlayerTrack";
import PlayModeDrop from "../layout/dropdown/PlayModeDrop";
import UIkit from "uikit";
import { connect } from "react-redux";
import { storage } from "../../firebase";
import {
  playOrPause,
  nextSong,
  prevSong,
  muteUnmute,
  volumeChange,
  playIcon,
  setTime,
  audioEnded,
} from "../../store/actions/audio";
import { AppPlayer } from "../../store/types/reducers";
import { RootState } from "../../store/reducers";
import { Track } from "../../models/track";

interface Props {
  playOrPause: Function;
  nextSong: Function;
  prevSong: Function;
  muteUnmute: Function;
  volumeChange: Function;
  playIcon: Function;
  setTime: Function;
  audioEnded: Function;
  audio: AppPlayer;
  paused: boolean;
  volume: number;
  current: Track;
  muted: boolean;
  ended: boolean;
  mode: typeof LINEAR | typeof SHUFFLE | typeof REPEAT | typeof REPEAT_1;
}

const Player: FC<Props> = ({
  playOrPause,
  nextSong,
  prevSong,
  muteUnmute,
  volumeChange,
  playIcon,
  setTime,
  audioEnded,
  audio,
  paused,
  current,
  muted,
  ended,
  mode,
  volume,
}) => {
  const { title, username, covername, uid } = current;
  const [cover, setCover] = useState("");

  const setTimeFromClick = (e: MouseEvent) => {
    if (audio.src) {
      let time = (e.clientX / window.innerWidth) * audio.duration;
      setTime(time);
    } else {
      UIkit.modal.dialog(`<p class="uk-modal-body">Select a song to play</p>`);
    }
  };

  const setTimeFromDrag = (e: MouseEvent) => {
    if (audio.src) {
      let time = (e.clientX / window.innerWidth) * audio.duration;
      setTime(time);
    }
  };

  useEffect(() => {
    const pbar = document.querySelector(".progress");
    // const end = document.querySelector(".end")

    pbar?.addEventListener("mouseenter", () => {
      const dot = document.querySelector(".end");
      dot?.setAttribute("style", "display: initial");
      // dot?.style.display = "initial"
    });

    pbar?.addEventListener("mouseleave", () => {
      const dot = document.querySelector(".end");
      dot?.setAttribute("style", "display: none");
      // dot.style.display = "none"
    });

    const progress = document.getElementById("progress-bar");
    audio.addEventListener("timeupdate", (e) => {
      let val = (audio.currentTime / audio.duration) * 100;
      progress?.setAttribute("style", `transform: translateX(${val - 100}%)`);
      // progress.style.transform = `translateX(${val - 100}%)`
    });
  }, []);

  useEffect(() => {
    audio.addEventListener("ended", (e) => {
      audioEnded();

      playOrPause();
    });
  }, [ended]);

  useEffect(() => {
    audio.addEventListener("play", (e) => {
      playIcon();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ended]);

  useEffect(() => {
    playIcon();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current]);

  useEffect(() => {
    let mounted = true;
    if (covername) {
      storage
        .ref(`covers/${uid}${covername}`)
        .getDownloadURL()
        .then((url) => {
          if (mounted) setCover(url);
        });
    } else {
      if (mounted) setCover("");
    }

    return () => {
      mounted = false;
    };
  }, [current]);

  return (
    <div className="player-items">
      <div className="pl">
        <div
          className="pcart"
          style={{
            background: cover ? `url(${cover})` : "#123",
            content: cover ? "" : "Art",
            color: "black",
          }}
        ></div>
        <div className="text">
          <div>{username}</div>
          <div className="smidek">
            <small>{title}</small>
          </div>
        </div>
      </div>
      <div className="progress" onClick={setTimeFromClick}>
        <div className="progress-bar" id="progress-bar">
          <div
            draggable="true"
            onDragEnd={setTimeFromDrag}
            onDrag={setTimeFromDrag}
            className="end"
          ></div>
        </div>
      </div>
      <div className="player-large pl-center">
        <div className="large-container">
          <div>
            <span
              uk-tooltip={`title: ${
                mode === SHUFFLE
                  ? "Shuffle"
                  : mode === LINEAR
                  ? "Linear"
                  : mode === REPEAT
                  ? "Repeal All"
                  : "Repeat 1"
              } ; delay: 1500 `}
            >
              <i className="material-icons-outlined md-24">
                {mode && mode === SHUFFLE
                  ? "shuffle"
                  : mode === LINEAR
                  ? "keyboard_tab"
                  : mode === REPEAT
                  ? "repeat"
                  : "repeat_one"}
              </i>
            </span>
            <PlayModeDrop />

            <span
              onClick={() => prevSong()}
              uk-tooltip="title:Previous; delay: 1000"
            >
              <i className="material-icons">chevron_left</i>
            </span>

            <span className="play">
              <span
                style={{
                  background: "transparent",
                  border: "none",
                }}
                onClick={() => playOrPause()}
                uk-tooltip={
                  paused
                    ? `title: play; delay: 1000`
                    : `title: pause; delay: 1000`
                }
              >
                <i className="material-icons">
                  {audio.paused && paused
                    ? "play_circle_outline"
                    : "pause_circle_outline"}
                </i>
              </span>
            </span>
            <span
              onClick={() => nextSong()}
              uk-tooltip="title: Next; ; delay: 1000"
            >
              <i className="material-icons">chevron_right</i>
            </span>
            <span
              onClick={() => muteUnmute()}
              uk-tooltip={
                muted
                  ? `title: Unmute; delay: 1000`
                  : `title: Mute; delay: 1000`
              }
            >
              <i className="material-icons-outlined md-24">
                {muted
                  ? "volume_mute"
                  : audio.volume < 1
                  ? "volume_down"
                  : "volume_up"}
              </i>
            </span>
          </div>
        </div>
      </div>
      <div className="pr player-small">
        <div className="actions">
          <span className="play">
            <span
              uk-tooltip={
                paused
                  ? `title: play; delay: 1000`
                  : `title: pause; delay: 1000`
              }
              style={{
                background: "transparent",
                border: "none",
              }}
              onClick={() => playOrPause()}
            >
              <i className="material-icons">
                {audio.paused && paused
                  ? "play_circle_outline"
                  : "pause_circle_outline"}
              </i>
            </span>
          </span>
          <span>
            <i className="material-icons">more_horiz</i>
          </span>
          <PlayerTrack track={current} />
        </div>
      </div>
      <div className="pr player-large">
        <div className="actions" style={{ display: "flex" }}>
          <span
            uk-tooltip={`title: Volume; delay: 1000`}
            style={{ marginBottom: "8px" }}
          >
            <input
              className="rslider"
              type="range"
              min="0"
              max="1"
              step="0.01"
              value={volume}
              onChange={(e) => {
                volumeChange(e.target.value);
              }}
            />
            {/* </form> */}
          </span>
          <span
            uk-toggle="target: #lyrics"
            uk-tooltip="title:Lyrics; delay: 1000"
          >
            <i className="material-icons-outlined md-24">description</i>
          </span>
          <span
            uk-toggle="target: #que-view"
            uk-tooltip="title:Que; delay: 1000"
          >
            <i className="material-icons-outlined md-24">subject</i>
          </span>
          <span>
            <i className="material-icons">more_horiz</i>
          </span>
          <PlayerTrack track={current} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  audio: state.songs.audio,
  paused: state.songs.paused,
  current: state.songs.current,
  muted: state.songs.muted,
  ended: state.songs.ended,
  mode: state.songs.mode,
  volume: state.songs.volume,
});

const mapDispatchToProps = {
  playOrPause,
  nextSong,
  prevSong,
  muteUnmute,
  volumeChange,
  playIcon,
  setTime,
  audioEnded,
};

export default connect(mapStateToProps, mapDispatchToProps)(Player);
